<template>
  <EditorContent
    :name="name"
    :editor="editor"
  />
</template>

<script>
import { EditorContent } from 'tiptap'
import uniqueId from 'lodash/uniqueId'


export default {
  name: 'BEditorContent',
  $_veeValidate: {
    value() {
      return this.value
    },
    name() {
      return this.name
    },
  },
  components: {
    EditorContent,
  },
  inheritAttrs: false,
  props: {
    value: String,
    editor: Object,
    name: {
      type: String,
      default: () => uniqueId('b-editor-content-'),
    },
  },
}
</script>
